/* Coilovers Direct — vehicle fitment on the storefront (Phase 2 plan §4, Tasks 3.1–3.4).
 * Data: window.cdFitment = { index: <selector index URL>, parts: '/collections/parts' } (header group), the index and per-make
 * files built by src/fitment/selector-index.js, and each product's fitment.vehicles JSON (embedded by snippets/cd-fitment-panel).
 * Garage: localStorage 'cd-garage' = { list: [{year, make, model, submodel, seg}], active: 0 } — at most 5, every access in
 * try/catch so private windows still work (the selector just forgets the car).
 * Collection filtering uses the fit-<year>-<make>-<model> tags the fitment writer puts on products (src/fitment/write.js). */
(function () {
  var cfg = window.cdFitment || {};
  var KEY = 'cd-garage', MAX = 5;

  function readGarage() {
    try { var g = JSON.parse(localStorage.getItem(KEY)); if (g && Array.isArray(g.list)) return g; } catch (e) { /* no storage */ }
    return { list: [], active: 0 };
  }
  function saveGarage(g) { try { localStorage.setItem(KEY, JSON.stringify(g)); } catch (e) { /* no storage */ } }
  function activeVehicle() { var g = readGarage(); return g.list[g.active] || null; }
  function sameVehicle(a, b) { return a.year == b.year && a.make === b.make && a.model === b.model && a.submodel === b.submodel; }
  function addVehicle(v) {
    var g = readGarage();
    g.list = g.list.filter(function (x) { return !sameVehicle(x, v); });
    g.list.unshift(v); g.list = g.list.slice(0, MAX); g.active = 0;
    saveGarage(g); document.dispatchEvent(new CustomEvent('cd:garage'));
  }
  function handleize(s) {
    return String(s).toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function fitTag(v) { return 'fit-' + v.year + '-' + handleize(v.make) + '-' + handleize(v.model); }
  // Products whose year tags would pass Shopify's 250-tag cap carry fit-<make>-<model> instead (src/fitment/write.js).
  function mmTag(v) { return 'fit-' + handleize(v.make) + '-' + handleize(v.model); }
  function label(v, withTrim) {
    return v.year + ' ' + v.make + ' ' + v.model + (withTrim !== false && v.submodel && v.submodel !== 'Base' ? ' ' + v.submodel : '');
  }
  function partsUrl(v) { return (cfg.parts || '/collections/parts') + '/' + fitTag(v); }
  // Shopify 301s a tag URL to the bare collection when no product carries the tag: remember what to try next.
  function goTags(base, tags, search) {
    try { sessionStorage.setItem('cd-go', JSON.stringify(tags)); } catch (e) { /* no storage: no fallback */ }
    window.location.assign(base + '/' + tags[0] + (search || ''));
  }
  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    return e;
  }

  // ---------------------------------------------------------------- data
  var cache = {};
  function getJson(url) {
    if (!cache[url]) cache[url] = fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    return cache[url];
  }
  function index() { return cfg.index ? getJson(cfg.index) : Promise.reject(new Error('no selector index')); }
  function makeFile(make) { return index().then(function (ix) { return getJson(ix.files[make]); }); }

  // ---------------------------------------------------------------- selector (hero)
  function initSelector(root) {
    var sel = { year: root.querySelector('[name=cd-year]'), make: root.querySelector('[name=cd-make]'),
      model: root.querySelector('[name=cd-model]'), submodel: root.querySelector('[name=cd-submodel]') };
    var go = root.querySelector('[data-cd-go]'), note = root.querySelector('[data-cd-note]');
    var tabs = root.querySelectorAll('[data-cd-seg]');
    var seg = 'auto', order = ['year', 'make', 'model', 'submodel'];
    var names = { year: 'Year', make: 'Make', model: 'Model', submodel: 'Any trim' };   // trim is optional (Charles 2026-10-28)

    function fill(name, values, keep) {
      var s = sel[name];
      s.innerHTML = '';
      s.appendChild(el('option', { value: '' }, names[name]));
      values.forEach(function (v) { s.appendChild(el('option', { value: v }, v)); });
      s.disabled = !values.length;
      if (values.length === 1) s.value = values[0];
      else if (keep && values.indexOf(keep) !== -1) s.value = keep;
    }
    function clearAfter(name) {
      for (var i = order.indexOf(name) + 1; i < order.length; i++) fill(order[i], []);
      update();
    }
    function update() {
      var ready = ['year', 'make', 'model'].every(function (n) { return sel[n].value; });
      go.disabled = !ready;
    }
    function setSeg(s, prefill) {
      seg = s;
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-cd-seg') === s ? 'true' : 'false'); });
      root.setAttribute('data-seg', s);
      fill('make', []); fill('model', []); fill('submodel', []);
      return index().then(function (ix) {
        var years = Object.keys(ix[seg] || {}).sort(function (a, b) { return b - a; });
        fill('year', years, prefill && prefill.year && String(prefill.year));
        if (sel.year.value) return onYear(prefill);
        update();
      });
    }
    function onYear(prefill) {
      clearAfter('year');
      return index().then(function (ix) {
        fill('make', ix[seg][sel.year.value] || [], prefill && prefill.make);
        if (sel.make.value) return onMake(prefill);
        update();
      });
    }
    function onMake(prefill) {
      clearAfter('make');
      return makeFile(sel.make.value).then(function (mk) {
        var models = Object.keys((mk[seg] || {})[sel.year.value] || {}).sort();
        fill('model', models, prefill && prefill.model);
        if (sel.model.value) return onModel(prefill);
        update();
      });
    }
    function onModel(prefill) {
      clearAfter('model');
      return makeFile(sel.make.value).then(function (mk) {
        var subs = Object.keys(mk[seg][sel.year.value][sel.model.value] || {}).sort();
        fill('submodel', subs, prefill && prefill.submodel);   // one trim (about half of cars): picked for you
        update();
      });
    }
    sel.year.addEventListener('change', function () { onYear(); });
    sel.make.addEventListener('change', function () { onMake(); });
    sel.model.addEventListener('change', function () { onModel(); });
    sel.submodel.addEventListener('change', update);
    tabs.forEach(function (t) { t.addEventListener('click', function () { setSeg(t.getAttribute('data-cd-seg')); }); });
    go.addEventListener('click', function () {
      var v = { year: Number(sel.year.value), make: sel.make.value, model: sel.model.value, submodel: sel.submodel.value, seg: seg };
      addVehicle(v);
      goTags(cfg.parts || '/collections/parts', [fitTag(v), mmTag(v)]);
    });
    var a = activeVehicle();
    setSeg(a && a.seg === 'moto' ? 'moto' : 'auto', a).catch(function () {
      if (note) { note.hidden = false; note.textContent = 'The vehicle selector could not load. Search by part number below, or ask us.'; }
    });
  }

  // ---------------------------------------------------------------- garage bar (header)
  function renderGarage(root) {
    var g = readGarage(), v = g.list[g.active];
    root.innerHTML = '';
    if (!v) {
      root.appendChild(el('span', { class: 'cd-garage__label' }, 'Add your vehicle to see parts that fit.'));
      root.appendChild(el('a', { href: '/#cd-find' }, 'Add vehicle'));
      return;
    }
    root.appendChild(el('span', { class: 'cd-garage__label' }, 'Your vehicle:'));
    if (g.list.length > 1) {
      var s = el('select', { 'aria-label': 'Switch vehicle' });
      g.list.forEach(function (x, i) { var o = el('option', { value: i }, label(x)); if (i === g.active) o.selected = true; s.appendChild(o); });
      s.addEventListener('change', function () { var gg = readGarage(); gg.active = Number(s.value); saveGarage(gg); document.dispatchEvent(new CustomEvent('cd:garage')); });
      root.appendChild(s);
    } else root.appendChild(el('b', {}, label(v)));
    root.appendChild(el('a', { href: partsUrl(v) }, 'Shop parts'));
    root.appendChild(el('a', { href: '/#cd-find' }, 'Change'));
    var clear = el('button', { type: 'button' }, 'Remove');
    clear.addEventListener('click', function () {
      var gg = readGarage(); gg.list.splice(gg.active, 1); gg.active = 0; saveGarage(gg); document.dispatchEvent(new CustomEvent('cd:garage'));
    });
    root.appendChild(clear);
  }

  // ---------------------------------------------------------------- product fit badge (Task 3.3)
  function yearsInclude(list, year) {
    return (list || []).some(function (y) { return Array.isArray(y) ? y[0] <= year && year <= y[1] : y == year; });
  }
  function renderFit(root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-cd-fit-json]').textContent) || {}; } catch (e) { /* no data */ }
    var out = root.querySelector('[data-cd-fit-status]'), v = activeVehicle();
    var fits = data.fits || {};
    var cls = 'cd-fitstatus', msg, link;
    if (data.universal) { cls += ' is-universal'; msg = 'Universal part — fits by size and spec, not by vehicle. Check the specs or ask us.'; }
    else if (!Object.keys(fits).length) { cls += ' is-unknown'; msg = 'No vehicle list for this part yet. '; link = ['/pages/contact-us', 'Ask us to check your car']; }
    else if (!v) { cls += ' is-unknown'; msg = 'Add your vehicle to check that this fits. '; link = ['/#cd-find', 'Add vehicle']; }
    else {
      var subs = (fits[v.make] || {})[v.model] || {};
      var trims = Object.keys(subs).filter(function (s) { return yearsInclude(subs[s], v.year); });
      var byModel = /sheet|title/.test(data.source || '');   // brand guide or title: model + years, not trims
      if (!v.submodel && trims.length) {   // no trim picked: say which trims it's listed for, unless that's all of them
        cls += ' is-check'; msg = 'Listed for the ' + label(v, false) + ' ' + trims.join(', ') + '. ';
        link = ['/#cd-find', 'Add your trim to check'];
        makeFile(v.make).then(function (mk) {
          var all = Object.keys(((mk[v.seg || 'auto'] || {})[v.year] || {})[v.model] || {});
          if (!byModel && all.length && all.every(function (t) { return trims.indexOf(t) !== -1; })) {
            out.className = 'cd-fitstatus is-fit'; out.textContent = 'Fits your ' + label(v, false) + ' (every trim).';
          }
        }).catch(function () { /* keep the cautious message */ });
      }
      else if (byModel && trims.length) { cls += ' is-check'; msg = 'Listed for the ' + label(v, false) + (data.source.indexOf('sheet') !== -1 ? ' in the brand\'s application guide' : ' by the product title') + ' — check your trim before you order. '; link = ['/pages/contact-us', 'Ask us']; }
      else if (yearsInclude(subs[v.submodel], v.year)) { cls += ' is-fit'; msg = 'Fits your ' + label(v) + '.'; }
      else if (trims.length) { cls += ' is-check'; msg = 'Listed for the ' + label(v, false) + ' ' + trims.join(', ') + ' — check your trim. '; link = ['/pages/contact-us', 'Ask us']; }
      else { cls += ' is-nofit'; msg = 'Not listed for your ' + label(v) + '. '; link = [partsUrl(v), 'See parts that fit']; }
    }
    out.className = cls; out.textContent = msg;
    if (link) out.appendChild(el('a', { href: link[0] }, link[1]));
  }

  // ---------------------------------------------------------------- collection banner (Task 3.4)
  function renderCollectionBanner(root) {
    var tags = (root.getAttribute('data-tags') || '').split(',').filter(Boolean);
    var fit = tags.filter(function (t) { return t.indexOf('fit-') === 0; })[0];
    var base = root.getAttribute('data-url'), v = activeVehicle();
    var noun = root.getAttribute('data-title').toLowerCase().replace(/^all /, '');   // "All parts" → "parts"
    // cd-go = tags still to try, first = the one just requested (set by goVehicle). No fit tag on the page means Shopify
    // redirected (no product carries it): try the next one, or say nothing is listed.
    var tries = null;
    try { tries = JSON.parse(sessionStorage.getItem('cd-go')); sessionStorage.removeItem('cd-go'); } catch (e) { /* no storage */ }
    if (tries && tries.length && !fit) {
      if (tries.length > 1) { goTags(base, tries.slice(1)); return; }
      root.innerHTML = ''; root.hidden = false;
      root.appendChild(el('span', {}, 'No ' + noun + ' are listed for your ' + (v ? label(v) : 'vehicle') + ' yet. '));
      root.appendChild(el('a', { href: '/pages/contact-us' }, 'Ask us to check your car'));
      return;
    }
    root.innerHTML = '';
    root.hidden = false;
    if (fit) {
      var mine = v && (fitTag(v) === fit || mmTag(v) === fit);
      root.appendChild(el('span', {}, 'Showing ' + noun + ' for ' + (mine ? 'your ' + label(v, false) : 'one vehicle') + '. '));
      if (mine && fit === mmTag(v)) root.appendChild(el('small', {}, 'Listed by model, not year — check the years on each product. '));
      // Parts that fit hundreds of cars (mostly H&R spacers and bolts) carry fit-<make>-<model> instead of year tags (250-tag
      // cap), so a year page can't list them. Count them and link there.
      if (mine && fit === fitTag(v)) {
        var mmUrl = base + '/' + mmTag(v);
        fetch(mmUrl, { redirect: 'manual' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
          var m = h.match(/id="ProductCount(?:Desktop)?"[^>]*>\s*(\d[\d,]*)/);
          var n = m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
          if (!n) return;
          var more = el('p', { class: 'cd-colbanner__more' });
          more.appendChild(document.createTextNode('Plus ' + n + ' part' + (n === 1 ? '' : 's') + ' listed for the ' + v.make + ' ' + v.model + ' by model, not year (mostly wheel spacers and bolts) — check the years on each. '));
          more.appendChild(el('a', { href: mmUrl }, 'See ' + (n === 1 ? 'it' : 'them')));
          root.appendChild(more);
        }).catch(function () {});
      }
      root.appendChild(el('a', { href: base + window.location.search }, 'Show all ' + noun));
      if (mine && v.submodel && v.submodel !== 'Base') root.appendChild(el('small', {}, ' Each product page confirms the ' + v.submodel + ' trim.'));
    } else if (v) {
      root.appendChild(el('span', {}, 'Your vehicle: ' + label(v) + '. '));
      var only = el('a', { href: base + '/' + fitTag(v) + window.location.search }, 'Show only parts that fit');
      only.addEventListener('click', function (e) { e.preventDefault(); goTags(base, [fitTag(v), mmTag(v)], window.location.search); });
      root.appendChild(only);
    } else root.hidden = true;
  }

  // ---------------------------------------------------------------- search: "RX7" / "RX 7" → "RX-7"
  // Shopify search treats "RX7" as a typo (RX-8s, RX350s come back); the index carries dash-less aliases of model names.
  function normaliseQuery(q, aliases) {
    var words = q.split(/\s+/).filter(Boolean), out = [], changed = false;
    for (var i = 0; i < words.length; i++) {
      var k1 = words[i].toLowerCase().replace(/[^a-z0-9]/g, '');
      var k2 = i + 1 < words.length ? k1 + words[i + 1].toLowerCase().replace(/[^a-z0-9]/g, '') : null;
      if (k2 && aliases[k2] && !/-/.test(words[i] + words[i + 1])) { out.push(aliases[k2]); i++; changed = true; }
      else if (aliases[k1] && !/-/.test(words[i])) { out.push(aliases[k1]); changed = true; }
      else out.push(words[i]);
    }
    return changed ? out.join(' ') : null;
  }
  function initSearch() {
    document.addEventListener('submit', function (e) {
      var f = e.target, input = f.querySelector && f.querySelector('input[name=q]');
      if (!input || !/\/search$/.test(f.getAttribute('action') || '')) return;
      index().then(function (ix) { var n = normaliseQuery(input.value, ix.aliases || {}); if (n) input.value = n; })
        .catch(function () {}).then(function () { f.submit(); });
      e.preventDefault();
    }, true);
    if (window.location.pathname === '/search') {   // arrived by link or predictive search
      var params = new URLSearchParams(window.location.search), q = params.get('q');
      if (q) index().then(function (ix) {
        var n = normaliseQuery(q, ix.aliases || {});
        if (n) { params.set('q', n); window.location.replace('/search?' + params.toString()); }
      }).catch(function () {});
    }
  }

  function renderAll() {
    document.querySelectorAll('[data-cd-garage]').forEach(renderGarage);
    document.querySelectorAll('[data-cd-fit]').forEach(renderFit);
    document.querySelectorAll('[data-cd-colbanner]').forEach(renderCollectionBanner);
  }
  function init() {
    document.querySelectorAll('[data-cd-ymm]').forEach(initSelector);
    initSearch();
    renderAll();
  }
  document.addEventListener('cd:garage', renderAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.cdGarage = { read: readGarage, add: addVehicle, fitTag: fitTag };
})();
